<!-- 
  详情页 - 回款记录
  props:
    id: 详情id
 -->

<template>
	<div class="v-tabs notes-list">
    <div class="head">
      <div class="total">
        累计{{paymentData.length}}笔回款记录
      </div>
      <div class="inline-item">
        <el-radio-group v-model="payStatus" @change="handlePayStatus" size="small">
          <el-radio-button :label="1">待收款</el-radio-button>
          <el-radio-button :label="2">已收款</el-radio-button>
          <el-radio-button :label="4">部分收款</el-radio-button>
        </el-radio-group>
      </div>
      <div class="inline-item">
        <el-date-picker
          v-model="date"
          @change="datepicker"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="width:180px"
          unlink-panels
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="inline-item">
        <el-button size="small" type="primary" @click="addPayment">新建回款</el-button>
      </div>
    </div>
    <div class="content" ref="content">
      <ul class="item-list">
        <li class="item center" v-if="!paymentData.length">暂无数据</li>
        <li class="item" v-for="item in paymentData">
          <span class="date">{{item.addTime}}</span>
          <div class="order">
            <div class="id" @click="paymentDetail(item.id)">
              <i class="ico orange">回</i>
              <a href="javascript:">{{item.paymentNo}}</a>
            </div>
            <div class="good">
              <span class="thumb">
                <i class="web-icon-dollar-circle"></i>
              </span>
              <span class="title">¥{{item.amount}}</span>
              <span class="price">{{item.percent}}</span>
            </div>
            <div class="response">负责人：{{item.userName}}</div>
            <span class="status">{{item.status}}</span>
            <span class="overday">{{item.overDay}}</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
    </div>

    
    <!-- 新建回款 -->
    <add-payment
      v-if="paymentShow"
      ref="payment"
      moduleName="paymentApi"
      :modal="false"
      :initData="initData"
      @closeDialog="paymentClose"
      @handleSelect="handleSelect">
    </add-payment>

    <!-- 新建 -->
    <add-new
      ref="addNew"
      :modal="false"
      v-if="addnewShow"
      @refresh="refresh"
      @closeForDetail="addnewShow=false"
      :addnewProp="addnewProp">
    </add-new>

    <transition name="slide">
      <associated-new
        ref="associatedNew"
        v-if="showAssociated"
        :attrValue="attrValue"
        :customerId="initData.customer.id"
        :module="module"
        :modal="false"
        @close="showAssociated = false"
        @emitObj="emitObj"
        @addNew="addNew">
      </associated-new>
    </transition>
<!--     <transition name="fade">
      <div class="detail-bg" style="z-index:2001" v-if="showAssociated" @click.stop="showAssociated=false"></div>
    </transition> -->
	</div>
</template>

<script>
import * as api from 'src/api'
import * as common from 'src/config/common-config'
import addPayment from 'components/modal/payment/add-payment'
import associatedNew from 'components/modal/associated-new'
import addNew from 'components/modal/add-new'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    moduleName: {
      type: String
    },
    loading: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      payStatus: 1,
      paymentData: [],
      date: [],
      moduleApi: common.moduleApi,
      // 分页信息
      page: {
        size: 10,
        total: '',
        page: 1,
        rows: 1
      },
      paymentShow: false,
      initData: {},
      showAssociated: false,
      attrValue: '',
      module: '',
      addnewProp: {},
      addnewShow: false
    }
  },
  computed: {
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    handlePayStatus (bol) {
      this.page.page = 1
      this.getList()
    },
    datepicker (val) {
      this.page.page = 1
      if (val) {
        this.date = val
      } else {
        this.date = []
      }
      this.getList()
    },
    getList () {
      const time = this.date && this.date.length && this.date[0]
      let url = '/paymentApi/getPayments.html'
      let params = {
        refId: this.id,
        refType: this.moduleApi[this.moduleName],
        payStatus: this.payStatus,
        addTime: time ? this.date : [],
        page: this.page.page,
        pageSize: this.page.size
      }
      api.post(url, params, (data) => {
        this.page.total = data.pageHelper.rowsCount
        this.page.rows = data.pageHelper.pageTotal

        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.page === 1) {
          this.paymentData = data.result
        } else {
          this.paymentData = this.paymentData.concat(data.result)
        }
      })
    },
    paymentDetail (id) {
      this.$emit('openDetail', 'paymentApi', id)
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getList()
    },

    // 新建回款
    addPayment () {
      let url = 'paymentApi/getAssociatedCustomerAndContract.do'
      let params = {
        refType: this.moduleName.replace('Api', ''),
        refId: this.id
      }
      api.post(url, params, (data) => {
        this.initData.customer = data.customer
        this.paymentShow = true
        this.$nextTick(() => {
          this.$refs.payment.dialogVisible = true
        })
      })
    },

    paymentClose () {
      this.paymentShow = false
      this.getList()
    },

    refresh () {
      this.getList()
      if (this.$refs.associatedNew) {
        this.$refs.associatedNew.getUserList()
      }
    },
    handleSelect (type, data) {
      this.module = type
      this.attrValue = data
      this.showAssociated = true
    },

    emitObj (data, module) {
      this.attrValue = data
      this.$refs.payment.dateSave(data, module)
      this.showAssociated = false
    },

    // 从associated-new来的新建表单
    addNew (obj) {
      this.addnewProp = {
        module: obj.module,
        templateId: obj.templateId ? obj.templateId : ''
      }
      if (obj.module === 'contractApi') {
        this.addnewProp.refId = this.initData.customer.id
        this.addnewProp.type = 'customerApi'
      }
      this.addnewShow = true
      if (this.$refs.addNew) {
        this.$refs.addNew.addNew(this.addnewProp)
      }
    }
  },
  components: {
    addPayment,
    associatedNew,
    addNew
  },
  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    }
  }
}
</script>

<style lang="less" scoped>


</style>


// WEBPACK FOOTER //
// returned-record.vue?57feeff7